import React from 'react'
import Error from '../../components/common/Error'

function Error404Page() {
  return (
    <div>
        <Error />
    </div>
  )
}

export default Error404Page